module.exports = __webpack_public_path__ + "img/FC.299ce071.png";